/** History API changes do not emit popstate; mounted route panels use this signal. */
export const APP_NAVIGATION_EVENT = "stoptrading:section-navigation";
